import { render, staticRenderFns } from "./ExportAddPagesConfig.vue?vue&type=template&id=f41fd68c"
import script from "./ExportAddPagesConfig.vue?vue&type=script&lang=js"
export * from "./ExportAddPagesConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f41fd68c')) {
      api.createRecord('f41fd68c', component.options)
    } else {
      api.reload('f41fd68c', component.options)
    }
    module.hot.accept("./ExportAddPagesConfig.vue?vue&type=template&id=f41fd68c", function () {
      api.rerender('f41fd68c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/Export/ExportAddPagesConfig.vue"
export default component.exports